import { RouteLocationRaw, RouteRecordRaw, useRoute } from "vue-router";
import { LOCALE_CATEGORIES } from "@/assets/locales/categories.ts";
import { customAsyncComponent } from "@/functions/customAsyncComponent";
import { WorkspaceId } from "@/sdk";
import { i18n } from "@/i18n";
import router from "@/router";
import { getAccountProfileRouteLocation } from "@/domains/-account/-profile/routes";

export function getAccountLegalTermsRouteRecord():RouteRecordRaw{
  return {
    name: 'account_legal_terms',
    path: 'legal-terms',
    component: customAsyncComponent(async () => import('./views/LegalTermsView.vue')),
      
    meta: {
      accountNav: true,
      localeCategories: [
        LOCALE_CATEGORIES.LEGAL_MENTIONS_GLOBAL,
        LOCALE_CATEGORIES.MY_ACCOUNT,
        LOCALE_CATEGORIES.ERRORS,
      ]
    }
  }
}

export function getAccountLegalTermsRouteLocation(workspaceId: WorkspaceId):RouteLocationRaw{
  return { name: 'account_legal_terms', params:{workspaceId} }
}